<!--? About-2 Area Start -->
<section class="about-area2 testimonial-area section-padding30 fix">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-5 col-md-11 col-sm-11">
        <!-- about-img -->
        <div class="about-img2">
          <img src="resources/img/gallery/matteo3.jpg" alt="">
          <!-- Shape -->
          <!--           <div class="shape-qutaion d-none d-sm-block">
            <img src="resources/img//gallery/qutaion.png" alt="">
          </div> -->
        </div>
      </div>
      <div class="col-lg-6 col-md-9 col-sm-9">
        <div class="about-caption">
          <!-- Section Tittle -->
          <div class="section-title mb-55">
            <span>Feedback</span>
            <h1>Cosa dicono i nostri clienti di noi</h1>
          </div>
          <!-- Testimonial Start -->
          <div class="h1-testimonial-active">
            <!-- Single Testimonial -->
            <blockquote class="generic-blockquote">
              <div class="single-testimonial">
                <div class="testimonial-caption">
                  <p>{{feedbacks[currentFeedIndex].testo}}</p>
                  <div class="rattiong-caption">
                    <span>{{feedbacks[currentFeedIndex].cliente}}</span>
                  </div>
                </div>
              </div>
            </blockquote>
          </div>
          <!-- Testimonial End -->
        </div>
        <div class="row align-content-center">
          <div class="col d-flex align-items-center justify-content-center">
            <a id="icons" class="slick-prev slick-arrow" (click)="getPrevious()" href="javascript:void(0);"><i class="bi bi-arrow-left h1"></i></a>
            <a id="icons" class="slick-prev slick-arrow" (click)="getNext()" href="javascript:void(0);"><i class="bi bi-arrow-right h1"></i></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- About-2 Area End -->
